import { MaterialReactTable } from 'material-react-table'

const UITableReport = ({columns, data, enableRowSelection, isLoading, isFetching, columnVisibility, setColumnVisibility}) => {
    return (
        <>
            <MaterialReactTable 
                columns={columns}
                data={data}
                onColumnVisibilityChange={setColumnVisibility}

                initialState={{
                    columnVisibility: columnVisibility
                }}

                state={{
                    isLoading,
                    showProgressBars: isFetching,
                    columnVisibility
                }}

                enableFilters={false}
                enableColumnFilters={false}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableTopToolbar={true}
                enableHiding={true}
                visibleInShowHideMenu={true}
                enableExpandAll={false}
                enableColumnActions={false}
                enableRowSelection={enableRowSelection}
                renderEmptyRowsFallback={({ table }) => {
                    return (
                        <p className="text-center mt-4 mb-4">
                            There is not information to display
                        </p>
                    )
                }}
            muiSelectCheckboxProps={({ table }) => ({
                align: 'center',
                size: 'small',
            })}
            muiSelectAllCheckboxProps={({ table }) => ({
                align: 'center',
                size: 'small',
            })}
                muiTablePaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100],
                }}
                selectAllMode='all'
            />
        </>
    )
}

export default UITableReport